<template>
<e-chart ref="chart" />
</template>

<script>
import {AXIS_LABEL, AXIS_LINE_STYLE, NUMBER_FONT_FAMILY} from './FactorCharts/chartStyle'
export default {
  name: 'AQIExcellentAvgChart',
  props: {
    data: {
      required: true,
      type: Object
    }
  },
  methods: {
    render (isReal) {
      let {xAxisData, seriesData} = this.data
      let chartOpt = {
        // title: {
        //   text: '2019-09较上月常规六项均值变化',
        //   left: 'right',
        //   top: 'top',
        //   textAlign: 'center'
        // },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 10
        },
        tooltip: {
          trigger: 'axis',
          appendToBody: true,
          formatter: (arg) => {
            return `${arg[0].marker}${arg[0].name} ${arg[0].value === '' ? '' : arg[0].value + '%'}`
          }
        },
        grid: [{
          top: 40,
          right: 20,
          bottom: 35,
          left: 20,
          containLabel: true
        }],
        xAxis: {
          type: 'category',
          data: xAxisData
        },
        yAxis: {
          name: '浓度平均值变化(%)',
          type: 'value',
          nameGap: 30,
          nameLocation: 'center',
          axisLine: {
            show: true,
            lineStyle: AXIS_LINE_STYLE
          },
          splitLine: {
            show: false
          },
          color: ['#F6DA40', '#FF8772', '#fac858', '#FC5474', '#73c0de', '#BD97EB', '#00C2DF', '#9a60b4', '#ea7ccc'],
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: NUMBER_FONT_FAMILY
          }
        },
        series: [{
          type: 'bar',
          data: seriesData,
          itemStyle: {
            color: '#EEAD0E'
          }
        }]
      }

      this.$refs.chart.setOpt(chartOpt)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/AQIExcellentAvgChart.vue